module.exports = __webpack_public_path__ + "static/img/six_icon2.2133eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/six_icon2.png
// module id = UjHX
// module chunks = 12